import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tab } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import store from "../../redux/store";
import { setActive_Tab } from "../../redux/slice/userSlice";
import NewPilotOrders from "./NewPilotOrders";
import ProcessingPilotOrders from "./ProcessingPilotOrders";
import DeliveredPilotOrders from "./DeliveredPilotOrders";
import RejectPilotOrders from "./RejectPilotOrders";
import {
  get_deliverd_list,
  get_new_order_list,
  get_processsing_list,
  get_rejected_list,
} from "../../redux/slice/pilotOrdersSlice";

const PilotOrder = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { active_tab } = useSelector((state) => state.user);
  const handleChange = (event, newValue) => {
    store.dispatch(setActive_Tab(newValue.toString()));
  };
  useEffect(() => {
    dispatch(get_new_order_list());
    dispatch(get_processsing_list());
    dispatch(get_deliverd_list());
    dispatch(get_rejected_list());
  }, []);
  const tabStyle = {
    default_tab: {
      color: "#000",
      backgroundColor: "#FFFFFF",
      fontSize: 15,
    },
    active_tab: {
      color: "#169e49",
      backgroundColor: "#FFFFFF",
      fontSize: 15,
    },
  };
  const getStyle = (isActive) => {
    return isActive ? tabStyle.active_tab : tabStyle.default_tab;
  };
  return (
    <>
      <div className="over_hidden " style={{ padding: 1 }}>
        <TabContext value={active_tab}>
          <TabList
            className="card"
            onChange={handleChange}
            variant="scrollable"
            // aria-label="lab API tabs example"
            // visibleScrollbar
            allowScrollButtonsMobile
            TabIndicatorProps={{
              style: {
                backgroundColor: "#169e49",
              },
            }}
          >
            <Tab
              style={getStyle(active_tab == 1)}
              label="New"
              // onClick={() => setActiveIndex(1)}
              value={"1"}
            />
            <Tab
              style={getStyle(active_tab == 2)}
              label="Processing"
              // onClick={() => setActiveIndex(2)}
              value={"2"}
            />
            <Tab
              style={getStyle(active_tab == 3)}
              label="Delivered"
              // onClick={() => setActiveIndex(3)}
              value={"3"}
            />

            <Tab
              style={getStyle(active_tab == 4)}
              label="Reject"
              // onClick={() => setActiveIndex(4)}
              value={"4"}
            />
          </TabList>
          <div className="mt20">
            <TabPanel style={{ padding: 0 }} value="1">
              <NewPilotOrders />
            </TabPanel>
            <TabPanel style={{ padding: 0 }} value="2">
              <ProcessingPilotOrders />
            </TabPanel>
            <TabPanel style={{ padding: 0 }} value="3">
              <DeliveredPilotOrders />
            </TabPanel>
            <TabPanel style={{ padding: 0 }} value="4">
              <RejectPilotOrders />
            </TabPanel>
          </div>
        </TabContext>
      </div>
    </>
  );
};

export default PilotOrder;
